window.c24LpFrameJsReady.then(function() {
    window.Check24 = window.Check24 || {};

    window.Check24.hoverOld = function (hoverEle, layerEle, callbackEnter, callbackLeave, timeout, explicit, closeEle) {
        timeout = timeout ? timeout : 0;
        let hover = $(hoverEle);
        let layer = $(layerEle);
        let close = closeEle ? closeEle : null;
        let timer;
        hover.on('mouseenter touchend', function (e) {
            let currentEle = $(this);
            if (e.type == 'touchend' && $(e.target).closest(layerEle).length === 0 && hover.hasClass('open')) {
                layer.css('visibility', 'hidden').hide();
                hover.removeClass('open');
                if (typeof callbackEnter == 'function') {
                    callbackEnter(currentEle);
                }
            } else {
                if (e.target.classList && !e.target.classList.contains(close)) {
                    timer = setTimeout(function () {
                        currentEle.addClass('open');
                        if (explicit) {
                            currentEle.find(layerEle).css('visibility', 'visible').show();
                        } else {
                            layer.css('visibility', 'visible').show();
                        }
                        if (typeof callbackEnter == 'function') {
                            callbackEnter(currentEle);
                        }
                    }, timeout);
                }
            }
        }).on('mouseleave', function () {
            clearTimeout(timer);
            layer.css('visibility', 'hidden').hide();
            hover.removeClass('open');
            if (typeof callbackLeave == 'function') {
                callbackLeave();
            }
        });
        $(document).on('mouseup touchend', function (e) {
            if (hover.hasClass('open')) {
                if (!hover.is(e.target) && hover.has(e.target).length === 0) {
                    layer.css('visibility', 'hidden').hide();
                    hover.removeClass('open');
                    if (typeof callbackLeave == 'function') {
                        callbackLeave();
                    }
                }
            }
        });
    };

    window.Check24.infoFrame = {
        init: function(link, height, ele, layer) {
            $(document).on('click', '.' + ele, function() {
                let layerHeight = $('.' + layer).find('.c24-info-frame').height();
                window.Check24.infoFrame.documentHeight = $(document).height();
                if ($(window).height() < (layerHeight + 200)) {
                    $('#c24-page-and-ads').css({
                        'height': layerHeight + 200,
                        'overflow': 'hidden',
                    });
                } else {
                    $('#c24-page-and-ads').css({
                        'height': $(window).height(),
                        'overflow': 'hidden',
                    });
                }
                $('#c24-page-container-footer').hide();
                $('.' + layer).css('visibility','visible');
                $('.c24-blocking-layer').height(layerHeight + 200);
                $('.c24-blocking-layer').show();
            });

            $('.c24-blocking-layer, .c24-info-frame-close').click(function() {
                if ($(this).closest('.c24-info-frame').length || $(this).hasClass('c24-blocking-layer')) {
                    $('.c24-blocking-layer').hide();
                    $('.' + layer).css('visibility','hidden');
                    $('#c24-page-container-footer').show();
                    $('#c24-page-and-ads').css({
                        'height': window.Check24.infoFrame.documentHeight,
                        'overflow': 'visible',
                    });
                }
            });
        },
        documentHeight: null,
    };

    window.Check24.homeTeaser = {
        beforeSlide: function() {},
    };

    window.Check24.toolTip = {
        opened: {},
        setup: function(eId, tId) {
            $('#' + eId).click(function() {
                window.Check24.toolTip.open(tId,this);
            });
        },
        init: function() {
            $(document).on('click', function(event) {
                window.Check24.toolTip.close(event.target);
            });
        },
        open: function(tId,ele) {
            $('#' + tId).show();
            this.opened[tId] = ele;
        },
        close: function(target) {
            $.each( window.Check24.toolTip.opened, function(key, value) {
                if ( target != value ) {
                    $('#' + key).hide();
                }
                delete( window.Check24.toolTip.opened.key );
            });
        },
    };

    window.Check24.tabbedBox = {
        initialized: false,
        init: function() {
            if (!window.Check24.tabbedBox.initialized) {
                window.Check24.tabbedBox.initialized = true;
                $('.c24-tab-group-js:not(.fix) .c24-tab-js').hide();
                $('.c24-tab-group-js ul.c24-tab-navi-js li a').on('click', function (e) {
                    window.Check24.tabbedBox.toggle($(this).prop('href'), $(this));
                    e.preventDefault();
                    return false;
                });
                $('.c24-tab-group-js').not('.fix').each(function () {
                    $(this).find('ul li a:first').click();
                });
            }
        },
        toggle: function(href, me) {
            let anc = href.match(/#[a-z0-9-_]*/ig);
            if ( anc.length ) {
                let box = me.closest('.c24-tab-group-js');
                let rel = anc[0].substr(1);
                box.find('.c24-tab-js').hide();
                box.find('.c24-tab-js_' + rel).show();
                box.find('li').removeClass('active');
                me.parent().addClass('active').blur();
            }
        },
    };

    window.Check24.clicktip = {
        active: false,
        init: function() {
            $('.c24-clicktip').each(function () {
                let clicktip = $(this);
                let clicktipContent = clicktip.find('.c24-clicktip-content');
                clicktipContent.html(
                    '<div class="c24-clicktip-inner">' +
				clicktipContent.html() +
				'<div class="c24-clicktip-corner">&nbsp;</div>' +
				'<div class="c24-clicktip-close">&nbsp;</div>' +
				'</div>',
                );
                clicktip.click(function() {
                    clicktip.addClass('c24-maximize-zindex');
                    clicktipContent.fadeIn('fast', function() {
                        window.Check24.clicktip.active = clicktipContent;
                    });
                });
            });
            $(document).click(function() {
                window.Check24.clicktip.close();
            });
        },
        close: function() {
            if (this.active) {
                this.active.closest('.c24-clicktip').removeClass('c24-maximize-zindex');
                this.active.fadeOut('fast');
                this.active = false;
            }
        },
    };

    window.Check24.faqTip = {
        active: false,
        init: function() {
            $('.c24-faqtip').each(function () {
                let faqtip = $(this);
                let faqtipContent = faqtip.find('.c24-faqtip-content');
                faqtipContent.html(
                    '<div class="c24-faqtip-inner">' +
				faqtipContent.html() +
				'<div class="c24-faqtip-corner">&nbsp;</div>' +
				'<div class="c24-faqtip-close">&nbsp;</div>' +
				'</div>',
                );
                faqtip.click(function(e) {
                    faqtip.addClass('maximize-zindex');
                    if (window.Check24.isIE6 && faqtip.hasClass('ie6-disabled')) {
                        return;
                    }
                    if (window.Check24.isIE6 || faqtip.hasClass('ie6-mode')) {
                        faqtipContent.show();
                        if (window.Check24.faqTip.active != faqtipContent) {
                            if (window.Check24.faqTip.active) {
                                window.Check24.faqTip.active.hide();
                            }
                            window.Check24.faqTip.active = faqtipContent;
                            e.stopPropagation();
                        }
                    } else {
                        faqtipContent.fadeIn('fast', function() {
                            window.Check24.faqTip.active = faqtipContent;
                        });
                    }
                });
                faqtip.find('.c24-faqtip-title').hover(
                    function() {
                        $(this).addClass('c24-faqtip-hover');
                    },
                    function() {
                        $(this).removeClass('c24-faqtip-hover');
                    },
                );
            });
            $(document).click(function() {
                window.Check24.faqTip.close();
            });
        },
        close: function() {
            if (this.active) {
                this.active.closest('.c24-faqtip').removeClass('maximize-zindex');
                if (window.Check24.isIE6) {
                    this.active.hide();
                } else {
                    this.active.fadeOut('fast');
                }
                this.active = false;
            }
        },
    };

    window.Check24.potential = {
        initialized: false,
        init: function () {
            if (!window.Check24.potential.initialized) {
                window.Check24.potential.initialized = true;
                window.Check24.hoverOld('.c24-sp-teaser-hover','.c24-hover-box','','',150,true,'c24-hover-box-close');
                let hoverEles = document.querySelectorAll('.c24-hover-box');
                hoverEles.forEach(function(hoverEle) {
                    if (hoverEle.classList && window.Check24.isTouchDevice()) {
                        let contentEle = hoverEle.querySelectorAll('.c24-hover-box-content')[0];
                        if (contentEle) {
                            let close = document.createElement('span');
                            close.classList.add('c24-hover-box-close');
                            contentEle.prepend(close);
                        }
                    }
                });
                $('.c24-hover-box-close').on('click', function () {
                    $('.c24-hover-box').css('visibility', 'hidden').hide();
                    $('.c24-sp-teaser-hover').removeClass('open');
                });
                $('.c24-hover-box-content a').on('click', function (e) {
                    e.stopPropagation();
                });
            }
        },
    };

    window.Check24.saving = {
        initialized: false,
        init: function () {
            if (!window.Check24.saving.initialized) {
                window.Check24.saving.initialized = true;
                window.Check24.hoverOld('.c24-saving-hover','.c24-saving-box',window.Check24.saving.mouseover,'',150,true,'c24-saving-box-close');
                let hoverEles = document.querySelectorAll('.c24-saving-box');
                hoverEles.forEach(function(hoverEle) {
                    if (hoverEle.classList && window.Check24.isTouchDevice()) {
                        let contentEle = hoverEle.querySelectorAll('.c24-saving-box-content')[0];
                        let close = document.createElement('span');
                        close.classList.add('c24-saving-box-close');
                        contentEle.prepend(close);
                    }
                });
                $('.c24-saving-box-close').on('click', function () {
                    $('.c24-saving-box').css('visibility', 'hidden').hide();
                    $('.c24-saving-hover').removeClass('open');
                });
                $('.c24-saving-box-content a').on('click', function (e) {
                    e.stopPropagation();
                });
            }
        },
        mouseover: function (ele) {
            let graph = $(ele).find('.c24-saving-graph');
            let graphWidth = graph.width();
            let boxWidth = $(ele).find('.c24-saving-box-content').width();
            let graphMinWidth = graph.find('.c24-saving-min').width();
            let graphMaxWidth = graphWidth - graphMinWidth;
            let minLabelWidth = graph.find('.c24-saving-min-label').width();
            let maxLabelWidth = graph.find('.c24-saving-max-label').width();
            let minLabelPos = graphMinWidth - (minLabelWidth / 2);
            let maxLabelPos = (maxLabelWidth / 2);
            let minLabelCornerPos = (minLabelWidth / 2) - 7;
            let maxLabelCornerPos = (maxLabelWidth / 2) - 5;
            let whiteSpace = boxWidth - 8 - graphWidth;
            let savingTotalWidth = $(ele).find('.c24-saving-total-text').width();
            // min label positioning
            if (minLabelPos < 0) {
                minLabelCornerPos = minLabelCornerPos + minLabelPos;
                minLabelPos = 0;
            }
            // reposition graph labels
            graph.find('.c24-saving-min-label').css('left', minLabelPos);
            graph.find('.c24-saving-max-label').css('right', -(maxLabelPos));
            graph.find('.c24-saving-min-bar').css('left', graphMinWidth - 4);
            graph.find('.c24-saving-min-label .c24-saving-min-corner').css('left', minLabelCornerPos);
            graph.find('.c24-saving-max-label .c24-saving-max-corner').css('right', maxLabelCornerPos);
            // check if max label has enough space or reposition
            if (whiteSpace < maxLabelPos) {
                graph.find('.c24-saving-max-label').css('right', -(whiteSpace));
                graph.find('.c24-saving-max-label .c24-saving-max-corner').css('right', whiteSpace - 5);
                graph.addClass('repositionGraph');
            }
            // check if max label has been repositioned and if min label has still enough space
            if (graph.hasClass('repositionGraph') && (((maxLabelWidth - whiteSpace) + minLabelWidth / 2) > graphMaxWidth)) {
                minLabelPos = minLabelPos - (((maxLabelWidth - whiteSpace) + minLabelWidth / 2) - graphMaxWidth) - 10;
                minLabelCornerPos = minLabelCornerPos + (((maxLabelWidth - whiteSpace) + minLabelWidth / 2) - graphMaxWidth) + 9;
                graph.find('.c24-saving-min-label').css('left', minLabelPos);
                graph.find('.c24-saving-min-label .c24-saving-min-corner').css('left', minLabelCornerPos);
            }
            // check if min label has enough space or reposition
            if (!graph.hasClass('repositionGraph') && (((maxLabelWidth / 2) + (minLabelWidth / 2)) > graphMaxWidth)) {
                minLabelPos = minLabelPos - ((maxLabelWidth / 2 + minLabelWidth / 2) - graphMaxWidth) - 10;
                minLabelCornerPos = minLabelCornerPos + minLabelPos + 5;
                graph.find('.c24-saving-min-label').css('left', minLabelPos);
                graph.find('.c24-saving-min-label .c24-saving-min-corner').css('left', minLabelCornerPos);
            }
            // position saving total if enough space
            if ((savingTotalWidth < (graphMaxWidth + (whiteSpace * 2))) && whiteSpace < graphMinWidth) {
                const savingTotalPos = graphMinWidth + ((graphMaxWidth - savingTotalWidth) / 2);
                $(ele).find('.c24-saving-total').css('left', savingTotalPos + 'px');
            } else {
                const savingTotalPos = (boxWidth - savingTotalWidth) / 2;
                $(ele).find('.c24-saving-total').css('left', savingTotalPos + 'px');
            }
        },
    };

    window.Check24.queryString = function () {
        let queryString = {};
        let decoder = function (uriString) {
            try {
                return decodeURIComponent(uriString);
            } catch (e) {
                return uriString;
            }
        };
        let query = window.location.search.substring(1);
        let vars = query.split('&');
        for (let i = 0;i < vars.length;i++) {
            let pair = vars[i].split('=');
            // If first entry with this name
            if (typeof queryString[pair[0]] === 'undefined') {
                queryString[pair[0]] = decoder(pair[1]);
            // If second entry with this name
            } else if (typeof queryString[pair[0]] === 'string') {
                let arr = [ queryString[pair[0]],decoder(pair[1]) ];
                queryString[pair[0]] = arr;
            // If third or later entry with this name
            } else {
                queryString[pair[0]].push(decoder(pair[1]));
            }
        }
        return queryString;
    }();

    window.Check24.BPM = {
        ajax: {},
        data: {},
        timeout: 1000,
        get: function(field, callback, product) {
            product = product !== undefined ? product : 'website';
            window.Check24.BPM.callbackList.push({
                field: field,
                callback: callback,
                product: product,
            });
            if (window.Check24.BPM.data[product] === undefined) {
                if (window.Check24.BPM.ajax[product] === undefined) {
                    window.Check24.BPM.ajax[product] = $.ajax({
                        type: 'GET',
                        url: '//www.' + window.Check24.getDomain() + '/ajax/bpm/get/',
                        contentType: 'application/json; charset=utf-8;',
                        crossDomain: true,
                        async: true,
                        timeout: window.Check24.BPM.timeout,
                        dataType: 'jsonp',
                        data: {
                            product: product,
                        },
                        success: function (json) {
                            window.Check24.BPM.data[product] = json.data;
                            window.Check24.BPM._callback();
                        },
                    });
                }
            } else {
                window.Check24.BPM._callback();
            }
        },
        getAll: function(callback, product) {
            if (typeof callback === 'function') {
                window.Check24.BPM.get('_all_', callback, product);
            } else {
                throw new Error('callback is not typeof function');
            }
        },
        callbackList: [],
        _callback: function() {
            for (let i = 0; i < window.Check24.BPM.callbackList.length; i++) {
                let entry = window.Check24.BPM.callbackList[i];
                if (window.Check24.BPM.data[entry.product] !== undefined) {
                    window.Check24.BPM.callbackList.splice(i, 1);
                    i--;
                    let val = window.Check24.BPM.data[entry.product][entry.field];
                    if (entry.field === '_all_') {
                        val = window.Check24.BPM.data[entry.product];
                    }
                    if (val === undefined) val = '';
                    if (typeof entry.callback === 'function') {
                        entry.callback(val);
                    } else {
                        if (val !== '' && typeof val !== 'undefined') {
                            let el = $(entry.callback);
                            if (el.is('input') && (el.prop('type') === 'checkbox' || el.prop('type') === 'radio')) {
                                el.prop('checked', JSON.parse(val));
                            } else {
                                el.val(val);
                            }
                        }
                    }
                }
            }
        },
        __setAjax: null,
        __setList: [],
        set: function(field, value, product) {
        // if no product is set, use default "website"
            product = product !== undefined ? product : 'website';
            // if empty request look at queue
            if (field === undefined) {
                if (window.Check24.BPM.__setList.length === 0) {
                    return;
                }
                let request = window.Check24.BPM.__setList.pop();
                field = request.__field;
                product = request.product;
                value = request[field];
            }
            // build query data
            let data = {
                product: product,
            };
            data[field] = value;
            // if set ajax is running, save request
            if (window.Check24.BPM.__setAjax !== null) {
                data.__field = field;
                window.Check24.BPM.__setList.push(data);
            } else {
            // Feld lokal speichern
                if (window.Check24.BPM.data[product] !== undefined) {
                    window.Check24.BPM.data[product][field] = value;
                }
                // Send set request
                window.Check24.BPM.__setAjax = $.ajax({
                    type: 'GET',
                    url: '//www.' + window.Check24.getDomain() + '/ajax/bpm/set/',
                    contentType: 'application/json; charset=utf-8;',
                    async: true,
                    timeout: 1000,
                    dataType: 'jsonp',
                    crossDomain: true,
                    data: data,
                    success: function() {
                        window.Check24.BPM.__setAjax = null;
                        // Start again if there is something in the queue
                        window.Check24.BPM.set();
                    },
                    error: function() {
                    // Try next
                        window.Check24.BPM.set();
                    },
                });
            }
        },
    };
});

window.c24DomReady(function() {
    window.c24LpFrameJsReady.then(function() {
        window.c24LpCssLoaded.then(function() {
            window.Check24.tabbedBox.init();
            window.Check24.toolTip.init();
            window.Check24.clicktip.init();
            window.Check24.faqTip.init();
            window.Check24.potential.init();
        });
    });
});
